import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAgencySynchronizerLogs, getAgencySynchronizedItems } from './api';
import { AgencySynchronizerLogsResponse, AgencySynchronizedItemsResponse } from './types';

type SyncLogsQueryOptions = Omit<UseQueryOptions<AgencySynchronizerLogsResponse, Error>, 'queryKey' | 'queryFn'>;
type SynchronizedItemsQueryOptions = Omit<
  UseQueryOptions<AgencySynchronizedItemsResponse, Error>,
  'queryKey' | 'queryFn'
>;

export function useGetAgencySynchronizerLogs(params?: Record<string, unknown>, options?: SyncLogsQueryOptions) {
  return useQuery<AgencySynchronizerLogsResponse>({
    queryKey: ['agency_synchronizer_logs', params],
    queryFn: () => getAgencySynchronizerLogs(params),
    ...options
  });
}

export function useGetAgencySynchronizedItems(
  synchronizerLogId: number | string | null,
  params?: Record<string, unknown>,
  options?: SynchronizedItemsQueryOptions
) {
  return useQuery<AgencySynchronizedItemsResponse>({
    queryKey: ['agency_synchronized_items', synchronizerLogId, params],
    queryFn: () => getAgencySynchronizedItems(synchronizerLogId!, params),
    enabled: Boolean(synchronizerLogId),
    ...options
  });
}
